<template>
   <div class="whole">
      <div class="nav">
         <van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
         <span>整装整租</span>
         <div></div>
      </div>
      <div class="main">
         <img src="../../../assets/01.jpg" alt="">
         <img src="../../../assets/02.jpg" alt="">
         <img src="../../../assets/03.jpg" alt="">
         <img src="../../../assets/04.jpg" alt="">
<!--         <img src="../../../assets/5.jpg" alt="">-->
<!--         <img src="../../../assets/6.jpg" alt="">-->
      </div>
      <div class="footer">
         <van-button color="#f1452f" type="primary" block @click="toWhole('/packages')">
            <span class="foot_span">进入整装整租</span>
            <img src="../../../assets/pointer.png" alt="">
         </van-button>
      </div>
      <!--登录 -->
      <van-popup v-model="loginPopupShow" position="bottom" :style="{ height: '100%' }">
         <div class="close-icon" @click="loginPopupShow=false">关闭</div>
         <Login :url="url"></Login>
      </van-popup>
   </div>
</template>

<script>
   import Login from '@/components/login/login'

   export default {
      data() {
         return {
            loginPopupShow: false,
				url: ''
         }
      },
      methods: {
         toWhole(path) {
            this.whatLogin((bool) => {
               if (bool) {
                  this.$router.push({
                     path: path
                  })
               } else {
                  this.loginPopupShow = true;
                  this.url = path;
               }
            })
         }
      },
      components: {
         Login
      }
   }
</script>

<style scoped>
   .whole {
      padding-bottom: 2.5rem;
      padding-top: 2rem;
   }

   .whole .main img {
      width: 100%;
      display: block;
      /*margin: 1px 0;*/
   }
   .footer{
      height:2.6rem;
   }
   .footer >>> .van-button--block{
      height:3.6rem;

   }

   .whole .footer {
      width: 100%;
      height: 3.5rem;
      position: fixed;
      bottom: 0;
     /*margin-top: 1px;*/
     border-top: 1px solid #fff;
   }

   .whole .footer .van-button__text {
      display: flex;
      align-items: center;
      justify-content: center;
   }

   .whole .footer .foot_span {
      font-size: 1rem;
   }

   .whole .footer img {
      width: 1.2rem;
      margin-left: 0.2rem;
   }
</style>



// WEBPACK FOOTER //
// src/components/home/whole/whole.vue